<template>
  <div
    id="report-sidebar"
    class="px-4 border rounded-lg flex flex-col w-full h-full bg-white py-4"
    v-loading="loading"
  >
    <el-form :model="form" :rules="formRules" ref="form">
      <div class="flex flex-col space-y-2">
        <el-form-item prop="reportType">
          <div class="flex w-full justify-between">
            <h5 class="text-base font-bold text-black">
              Report Type
            </h5>
            <el-button
              id="collapse-button"
              class="mb-2"
              size="mini"
              icon="el-icon-close"
              style="height: 40px;"
              @click="$emit('showSidebar', false)"
              >Collapse</el-button
            >
          </div>
          <div class="w-full">
            <el-select
              v-model="form.reportType"
              filterable
              clearable
              remote
              reserve-keyword
              placeholder="Search Report"
              :loading="loading"
            >
              <el-option
                v-for="item in reports"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
        </el-form-item>

        <el-form-item prop="locationReportNode">
          <h5 class="text-base font-bold text-black">Location</h5>
          <el-cascader
            v-model="form.locationReportNode"
            :options="location"
            :props="cascaderProps"
            clearable
            filterable
            class="w-full mt-2"
          />
        </el-form-item>

        <el-form-item prop="dataForm">
          <h5 class="text-base font-bold text-black">Report Period</h5>
          <el-select
            v-model="form.dataForm"
            @change="onChangePicker"
            placeholder="Select Report Period"
            class="w-full mt-2"
          >
            <el-option
              v-for="item in dateOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <h5 class="text-base font-bold text-black mt-2">Period Range</h5>
        <div class="flex justify-between">
          <el-form-item prop="startDate">
            <el-date-picker
              v-model="form.startDate"
              class="mt-2 mr-1"
              :picker-options="datePickerOptions"
              :type="periodDatePickerType"
              placeholder="Start Period"
              value-format="yyyy-MM-dd"
              @change="validateDate"
            />
          </el-form-item>
          <el-form-item prop="endDate">
            <el-date-picker
              v-model="form.endDate"
              class="ml-1 mt-2"
              :picker-options="datePickerOptions"
              :type="periodDatePickerType"
              placeholder="End Period"
              value-format="yyyy-MM-dd"
              @change="validateDate"
            />
          </el-form-item>
        </div>

        <el-form-item prop="customer" v-if="!isCustomer">
          <h5 class="text-base font-bold text-black">
            Tenant
          </h5>
          <div class="w-full mt-2">
            <el-select
              v-model="form.customer"
              filterable
              clearable
              remote
              reserve-keyword
              placeholder="Select Customer"
            >
              <el-option
                v-for="item in customerList"
                :key="item.DcoId"
                :label="item.Company"
                :value="item.DcoId"
              >
              </el-option>
            </el-select>
          </div>
        </el-form-item>

        <el-form-item label="Formula" class="_hidden">
          <el-input placeholder="Search Formula" v-model="filterText">
          </el-input>
          <div class="border">
            <el-tree
              show-checkbox
              default-expand-all
              ref="deviceGroupsTree"
              node-key="Dce_id"
              highlight-current
              empty-text="No Data"
              :default-checked-keys="checkedKeys"
              :data="deviceGroups"
              :props="deviceGroupProps"
              :filter-node-method="filterNode"
              :check-on-click-node="true"
              @check-change="onDeviceGroupChange"
            >
            </el-tree>
          </div>
        </el-form-item>

        <div class="flex justify-between mt-2">
          <el-button
            class="w-full"
            icon="el-icon-check"
            type="primary"
            @click="submitFilter(false)"
            >Submit</el-button
          >
          <el-button class="w-full" @click="resetForm('form')">Reset</el-button>
        </div>
        <el-button
          icon="el-icon-date"
          type="success"
          :disabled="disableScheduleButton"
          @click="popupScheduleOpen = true"
          >Schedule a Report</el-button
        >
      </div>
    </el-form>

    <PopupSchedule
      :reportForm="form"
      :popup-schedule-open="popupScheduleOpen"
      @closePopup="closePopup"
    />
  </div>
</template>

<script>
import PopupSchedule from '@/components/Popup/Schedule'
import reportFilterMixin from '@/mixins/ReportFilter'

export default {
  components: {
    PopupSchedule
  },
  mixins: [reportFilterMixin],
  props: {
    reportType: {
      type: String
    },
    disableScheduleButton: {
      type: Boolean
    }
  },
  data() {
    return {
      form: {
        startDate: '',
        endDate: '',
        reportType: '',
        locationReport: [],
        locationReportNode: ['ONEDC'],
        dataForm: 'daily',
        customer: '',
        ListFormula: []
      },
      dateOptions: [
        {
          value: 'daily',
          label: 'Daily'
        },
        {
          value: 'monthly',
          label: 'Monthly'
        },
        {
          value: 'yearly',
          label: 'Yearly'
        }
      ],
      formRules: {
        reportType: [
          {
            required: true,
            message: 'Report Type is required',
            trigger: 'change'
          }
        ],
        dataForm: [
          {
            required: true,
            message: 'Report Period is required',
            trigger: 'blur'
          }
        ],
        startDate: [
          {
            required: true,
            message: 'Start Period is required',
            trigger: 'blur'
          }
        ],
        endDate: [
          {
            required: true,
            message: 'End Period is required',
            trigger: 'blur'
          }
        ],
        locationReportNode: [
          {
            required: true,
            message: 'Location is required',
            trigger: 'blur'
          }
        ],
        customer: [
          {
            required: true,
            message: 'Tenant is required',
            trigger: 'blur'
          }
        ],
        ListDceId: [
          {
            required: true,
            message: 'Device Group is required',
            trigger: 'blur'
          }
        ]
      },
      submitted: false,
      sidebarOpen: true,
      popupScheduleOpen: false,
      checkedKeys: []
    }
  },
  watch: {
    deviceGroups(val) {
      this.disableTreeItem(this.deviceGroups)
    }
  },
  mounted() {
    this.getCustomSensors()
    this.getLocations()
    this.getReportTypes()
    this.setDefaultCustomerId()
    this.getCustomers(this.form.locationReportNode)

    // set filter data from query parameter
    if (Object.prototype.hasOwnProperty.call(this.$route.query, 'customer')) {
      for (var prop in this.$route.query) {
        this.form[prop] = this.$route.query[prop]

        if (
          prop === 'locationReportNode' &&
          !Array.isArray(this.$route.query[prop])
        ) {
          this.form[prop] = [this.$route.query[prop]]
        }
      }

      // autofill deviceGroupsTree
      this.$refs.deviceGroupsTree.setCheckedKeys(this.$route.query.ListFormula)

      // submit data
      this.submitFilter(true)
    }
  },
  methods: {
    disableTreeItem(children) {
      children.forEach((child) => {
        child.disabled = true
        if (child.children) this.disableTreeItem(child.children)
      })
    }
  }
}
</script>

<style>
#report-sidebar .el-select {
  width: 100% !important;
}
#report-sidebar .el-tree {
  max-height: 300px;
  overflow: auto;
}
#report-sidebar .el-form-item {
  margin-bottom: 0 !important;
}
#report-sidebar .el-form-item .el-form-item__error {
  display: none !important;
}
#report-sidebar .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
</style>
